<template>
  <v-layout align-center justify-center row fill-height class="browser-alert" v-if="show">
    <v-flex class="shrink fill-height nowrap">하우스북은 최신브라우저에 최적화되어 있습니다.</v-flex>
    <v-flex class="shrink fill-height"><a href="https://www.google.com/chrome/" target="_blank"><img class="chrome" :src="`${getStaticUrl()}/chrome-logo.svg`"/></a></v-flex>
    <v-flex class="shrink fill-height"><a href="https://www.opera.com/ko" target="_blank"><img class="opera" :src="`${getStaticUrl()}/opera-logo.svg`"/></a></v-flex>
    <v-flex class="shrink fill-height"><a href="https://www.mozilla.org/ko/firefox/new/?redirect_source=firefox-com" target="_blank"><img class="firefox" :src="`${getStaticUrl()}/firefox-logo.svg`"/></a></v-flex>
    <v-flex class="shrink fill-height ml-3"><div class="browser-alert-close" @click="close()"><v-icon>close</v-icon></div></v-flex>
  </v-layout>
</template>

<script>
import Utile from '@/utile/utile'

export default {
  data: () => ({
    show: false
  }),
  mounted () {
    var agent = navigator.userAgent.toLowerCase()
    if ((navigator.appName === 'Netscape' && agent.indexOf('trident') !== -1) || (agent.indexOf('msie') !== -1)) {
      const date = new Date()
      const day = date.getDate()
      if (localStorage.getItem('browserAlert') !== day) {
        this.show = true
      }
    }
  },
  methods: {
    getStaticUrl () {
      return Utile.getStaticUrl()
    },
    close () {
      const date = new Date()
      const day = date.getDate()
      localStorage.setItem('browserAlert', day)
      this.show = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/BrowserAlert.vue